/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function recommendationsInCartAux(){
   $('.product-recommendations-cart').html('<img id="loading" src="https://cdn.shopify.com/s/files/1/0622/5245/0042/files/loading.gif?v=1749020646" />');
     if($(".Cart__Empty").length == 0)
      {
        $.ajax({
        url: window.Shopify.routes.root + "recommendations/products?product_id="+$('.CartItem__Id').first().text()+"&limit=4&section_id=cart-recommendations-section&intent=related",
        context: document.body
        }).done(function(data) {
            $('.product-recommendations-cart').html(data)
        });
      }else{
        $('.product-recommendations-cart').html()
      }      
}


  function recommendationsInCart(){
   $('.product-recommendations-cart').html('<img id="loading" src="https://cdn.shopify.com/s/files/1/0622/5245/0042/files/loading.gif?v=1749020646" />');
   setTimeout(() => {
     if($(".Cart__Empty").length == 0)
      {
        $.ajax({
        url: window.Shopify.routes.root + "recommendations/products?product_id="+$('.CartItem__Id').first().text()+"&limit=4&section_id=cart-recommendations-section&intent=complementary",
        context: document.body
        }).done(function(data) {
           if(data.length<=130){
            recommendationsInCartAux()
          }else{
            $('.product-recommendations-cart').html(data)
          }
        });
      }else{
        $('.product-recommendations-cart').html()
      }

     }, 1500);
  }
$( document ).ready(function() {
  recommendationsInCart();

/*  $('#sidebar-cart').on( "change", function() {
    recommendationsInCart();
  } );

  $('.Icon-Wrapper--clickable').on( "click", function() {
    recommendationsInCart();
  } );

  $('.ProductForm__AddToCart').on( "click", function() {
    recommendationsInCart();
  } );*/
  
 $('.buy-buttons .button').on( "click", function() {
      recommendationsInCart();  
  } );
  
  $('.header__nav-icon.icon.icon-cart').on( "click", function() {
      recommendationsInCart();  
  } );

  $('#cart-drawer').on( "click", function() {
      recommendationsInCart();  
  } );


});